import { InfoItem, formatDate } from "../../../utils/utils";
import { billingStateLabel, useBillingAccess } from "../../../utils/useBillingAccess";

export default function BillingDetailsCard({ accountUser, paymentMethod, planStarted }) {
    const access = useBillingAccess(accountUser);
    const plan = accountUser?.plan || {};
    return <section className="bg-white rounded border border-[#d7d8d2] overflow-hidden" aria-labelledby="billing-details-title">
        <div className="px-5 py-4 border-b border-[#e4e5e7]"><h2 id="billing-details-title" className="font-semibold text-base">Billing details</h2></div>
        <div className="p-5 grid grid-cols-1 md:grid-cols-2 gap-4">
            <InfoItem label="Status" value={billingStateLabel(access, plan)} />
            <InfoItem label={access.state === 'trial' ? 'Existing trial ends' : 'Verified paid through'} value={(access.state === 'trial' ? plan.trialEndsAt : access.paidThroughAt) ? formatDate(access.state === 'trial' ? plan.trialEndsAt : access.paidThroughAt) : 'Not yet verified'} />
            <InfoItem label="Next automatic renewal" value={plan.cancelAtPeriodEnd ? 'Cancelled' : plan.nextBillingDate ? formatDate(plan.nextBillingDate) : 'Not scheduled'} />
            <InfoItem label="Payment method" value={paymentMethod || 'No saved payment details'} />
            {planStarted && <InfoItem label="Plan started" value={formatDate(planStarted)} />}
            {access.state === 'grace' && <InfoItem label="Grace period ends" value={formatDate(access.graceUntilAt)} />}
        </div>
    </section>;
}
